import { AuthenticatedService } from "../../infrastructure";
import { ISuggestRepository } from "../../domain/system";

export class SuggestRepository extends AuthenticatedService implements ISuggestRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  async getSuggests(identifier: string, userCode: string, keyword: string): Promise<string[]> {
    const url = "/api/suggest/get";
    const data = {
      token: this.token,
      identifier,
      userCode: userCode,
      keyword
    };
    const result = await this.post(url, data);
    return result.data;
  }

  async registerSuggest(identifier: string, userCode: string, keyword: string): Promise<void> {
    const url = "/api/suggest/register";
    const data = {
      token: this.token,
      identifier,
      userCode: userCode,
      keyword
    };
    await this.post(url, data);
  }
}
